fx.ns("shared.popups", class RegisteredPopup extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personHappy);
        this.contentWidth = 470;
        this.contentHeight = 230;
    }

    create()
    {
        super.create();

        // title
        this.addChild(new fx.components.Text({text:fx.text("Votre album est sauvegardé !"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("A partir de maintenant, votre album est sauvegardé automatiquement."), className:"text center"}));

        this.addFooterChild("close");
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onClose, this.okButton);
    }



});